import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Home } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import mixpanel from "@/lib/mixpanel";

interface SidebarConsoleSectionProps {
  onClick: () => void;
  isActive: boolean;
  isExpanded: boolean;
  isMiniMode: boolean;
}

const SidebarConsoleSection: React.FC<SidebarConsoleSectionProps> = ({
  onClick,
  isActive,
  isExpanded,
  isMiniMode,
}) => {
  const [isHovered, setIsHovered] = useState(false);

  const handleConsoleClick = () => {
    mixpanel.track("Click", { eventDescription: "Console" });
    onClick();
  };

  if (isMiniMode) {
    return (
      <TooltipProvider delayDuration={0}>
        <Tooltip open={isHovered}>
          <TooltipTrigger asChild>
            <Button
              variant="ghost"
              size="icon"
              className={`w-12 h-12 rounded-full relative group text-muted-foreground hover:text-foreground dark:hover:text-black hover:bg-sky-100 ${
                isActive ? "bg-sky-50 dark:bg-sky-900/20" : ""
              }`}
              onClick={handleConsoleClick}
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              <div className="flex items-center">
                <span
                  className={
                    isActive
                      ? "text-sky-500"
                      : "group-hover:text-foreground dark:group-hover:text-black"
                  }
                >
                  <Home size={20} />
                </span>
              </div>
            </Button>
          </TooltipTrigger>
          <TooltipContent
            side="right"
            sideOffset={10}
            align="center"
            className="-translate-y-[40%]"
          >
            <p>Console</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  }

  return (
    <Button
      variant="ghost"
      className={`h-[44px] w-full rounded-full text-md justify-start hover:bg-sky-100 gap-2 ${
        isActive
          ? "font-bold text-foreground dark:text-foreground bg-sky-100 dark:bg-sky-900/20"
          : "text-muted-foreground hover:text-foreground dark:hover:text-black hover:bg-sky-100 hover:underline"
      }`}
      onClick={handleConsoleClick}
    >
      <span className={isActive ? "text-sky-500" : ""}>
        <Home size={20} />
      </span>
      {isExpanded && "Console"}
    </Button>
  );
};

export default SidebarConsoleSection;
